import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { MERZ_ROUTES } from 'src/app/merz-routes';
import { NotificationApiClientService } from 'src/app/services/api/notification-api-client/notification-api-client.service';

const POLL_INTERVAL_MS = 60_000; // 1 minuto

@Component({
  selector: 'merz-notification-button',
  templateUrl: './notification-button.component.html',
  styleUrls: ['./notification-button.component.scss']
})
export class NotificationButtonComponent implements OnInit, OnDestroy {
  @Input() desktop = false;
  notiCount = 0;
  private pollTimer: any;

  constructor(
    protected navController: NavController,
    protected notificationApiClientService: NotificationApiClientService
  ) { }

  ngOnInit() {
    this.notificationApiClientService.notificationsReadEvent.subscribe(() => {
      this.getNotifications();
    });
    this.getNotifications();
    this.pollTimer = setInterval(() => this.getNotifications(), POLL_INTERVAL_MS);
  }

  ngOnDestroy() {
    if (this.pollTimer) {
      clearInterval(this.pollTimer);
    }
  }

  getNotifications(){
    this.notificationApiClientService.filter({read: false}).all().subscribe((result: any) => {
      this.notiCount = result['count'];
    });
  }

  get isNoti(){
    return this.notiCount !== 0;
  }

  get notiText(){
    return this.notiCount > 9 ? '+9': this.notiCount;
  }

  goToNotifications(){
    this.navController.navigateForward([MERZ_ROUTES.notificationsComplete]);
  }

}
